<template>
	<div class="index-page">
		    <app-banner :listImg="listImg"></app-banner>
            <div class="pinpailogo">
				<li><img src="../../assets/brand.png"></li>
				<p>品牌释义</p>
			</div>
			<div class="pinpai_logo">
				<img class="" src="../../assets/yes.png">
			</div>	
			<div class="ae">
				<img src="../../assets/wei.png">
			</div>
			<div class="pinpai_text">
				<p class="pintai_txt1 t_txt_style">各位妈妈们深入印尼不断考察对比，在印度尼西亚加里曼丹岛，找到更适合孕期妈妈吃的上品燕窝，那里的每一盏代表爱与希望的燕铺燕窝都在等待着被送往亿万家庭。</p>
				
			<div class="fei_list">
			<div class="list_left">
				<img src="../../assets/fei.png">
				</div>
			<div class="list_r">
				<div class="nwn">
					<img src="../../assets/nnn.png">
					
				</div>
				<p  class="xnx">代表当代新女性身上兼具着优雅、自信、智慧、坚强、勇敢的一种新时代力量，诠释燕铺的产品也有着新女性身上的力量感。</p>
			</div>	
				
			</div>
			<p class="zz">0漂染、0刷胶、0添加，燕铺燕窝品质始终如一，源力滋养，好孕安享，不管是燕窝的源头，还是宝宝成长的源头，有关这份爱的力量，激励着每位妈妈努力去寻找更高品质的燕窝，而对品质的追求正是燕铺的宗旨。</p>	
				
			</div>
			<div class="pinpaistory hidden-mb">
			</div>
			<div class="jinju">
			<p class="yong">用一盏燕窝</p>
			<p class="fusu">复苏世间万物能量本源</p>
			<p class="quanxin">用一份全心</p>
			<p class="huanxing">唤醒每个女性美丽人生</p>
			<p><img src="../../assets/xiajiantou.png"></p>
			</div>
			<div style="" class="shechongfuwu">
				<p class="shechongfuwulogo"><img src="../../assets/uxury.png"></p>
				<p class="shechongfuwutexte">奢宠服务</p>
				<img src="../../assets/renwu.jpg">
				<div class="border">
					<div class="border_nr">
                        <p class="shechongfuwu_p">为千万孕妈解决孕期问题</p>
						<div class="shechongfuwu_foot">
							<ul>
								<li class="li1">更精确的解决办法</li>
								<li class="li2">更科学的营养方案</li>
								<li class="li3">更人性化的奢宠服务</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
      </div>      
</template>

<script>
		 import Banner from '@/components/banner'
		 import a from '@/assets/banner1.jpg'
		//  import b from '@/assets/banner2.png'
		//  import c from '@/assets/banner3.png'
export default {
  name: 'myhome',
  data () {
    return {
    	 listImg: [
		                {url: a}, 
		                
                ],
    }
  },
  methods:{
		
		},
  components: {
            'app-banner': Banner,
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pinpailogo {
    padding-top: 135px;
    min-width: 1120px;
    margin: 0 auto;
    text-align: center;
    cursor: default;
}
.pinpailogo li {
    text-align: center;
    font-size: 32PX;
    letter-spacing: 6PX;
    display: block;
}
.pinpailogo p {
    font-size: 40px;
    letter-spacing: 16px;
    color: #1b1b1b;
    text-align: center;
    margin-top: 28px;
    margin-left: 34px;
}
.pinpai_logo {
    width: 532px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px;
}
.pinpai_logo img {
    width: 100%;
}
.ae {
    width: 316px;
    margin: auto;
    margin-top: 38px;
}
.ae img {
    width: 100%;
}
.pinpai_text {
    width: 1120px;
    height: 949px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 99;
}
.pintai_txt1 {
    text-indent: 2em;
    padding: 0 73px;
    text-align: left;
    line-height: 45px;
    margin-top: 31px;
}
.t_txt_style {
    text-align: left !important;
    text-indent: 3rem;
    letter-spacing: 2px;
    line-height: 60px;
    font-size: 23px;
    color: #000000;
}
.fei_list {
    width: 920px;
    margin: auto;
    margin-top: 106px;
    overflow: hidden;
}
.list_left {
    width: 249px;
    float: left;
}
.list_r {
    width: 614px;
    float: right;
}
.nwn {
    width: 415px;
    margin-top: 30px;
}
.xnx {
    margin-top: 28px;
    font-size: 20px;
    text-indent: 2em;
    color: #000000;
    letter-spacing: 4px;
    line-height: 39px;
        text-align: left;
}
.zz {
    width: 949px;
    height: 144px;
    margin: auto;
    margin-top: 115px;
    font-size: 23px;
    text-indent: 2em;
    line-height: 50px;
        text-align: left;
}
.pinpaistory {
    background: url(../../assets/bg.png) center center no-repeat;
    width: 1120px;
    height: 680px;
    margin: auto;
    margin-top: 400px;
    position: absolute;
    margin-left: -560px;
    left: 50%;
    top: 1427px;
    z-index: 1;
}
.jinju {
    width: auto;
    margin-top: 486px;
    font-size: 23px;
    text-align: center;
    color: #000000;
}
.jinju p {
    margin: 20px 0px;
}
.shechongfuwu {
    width: 1120px;
    margin: auto;
    text-align: center;
    cursor: default;
}
.shechongfuwulogo {
    width: 460px;
    height: 32px;
    margin: auto;
    margin-top: 44px;
}
.shechongfuwulogo img {
    width: 100%;
}
.shechongfuwutexte {
    margin-top: 28px;
    font-size: 42.23px;
    color: #1B1B1B;
    letter-spacing: 20px;
}
.border {
    width: 1120px;
    margin: auto;
    margin-top: 41px;
}
.border_nr {
    padding-bottom: 30px;
}
.shechongfuwu_p {
    font-size: 42.23px;
    letter-spacing: 5px;
    color: #1b1b1b;
    margin-top: 33px;
}
.shechongfuwu_foot {
    width: 1120px;
    margin: 24px auto;
    color: #FFFFFF;
}
.shechongfuwu_foot UL{ display: flex; justify-content: center;}
.shechongfuwu_foot li {
    margin: 0 18px;
    display: block;
    width: 261px;
    height: 40px;
    font-size: 23px;
    line-height: 40px;
    color: #000000;
    border: 1px solid #000000;
}
 .hidden-pc{ display:none !important;}
  .hidden-mb{ display:block !important;}
  @media(max-width: 750px) {
      .hidden-pc{ display: block !important;}
    .hidden-mb{ display: none !important;}
    .pinpailogo{
         min-width: 750px;
         width: 750px;
    }
    .pintai_txt1{ padding: 30px;font-size: 24px}
    .pinpai_text{ height: auto;}
    .jinju{ margin-top: 0; font-size: 24px}
    .pinpai_text,.fei_list,.pinpaistory,.shechongfuwu,.border,.shechongfuwu_foot{ width: 750px;}
    .zz{ width: 690px; margin: 0 auto; height: auto; font-size: 14px; display: none;}
    .list_left{ float: none; margin: 0 auto;}
    .list_r{float: none;  width: 690px; margin: 0 auto;}
    .nwn{ width: 640px; margin: 30px auto 0;}
    .nwn img{ width: 100%}
    .xnx{ margin-bottom: 50px;font-size: 24px}
    .pinpailogo li{ width: 690px; margin: 0 auto;}
    .pinpailogo li img{ width: 100%}
    .shechongfuwu img{ width: 100%;}
    .ae{ width: 500px}
    .pinpailogo{ padding-top: 65px}
  }
</style>



// WEBPACK FOOTER //
// src/components/myhome/myhome.vue